import React from 'react';

import { LinkProps, UnderlineTypeProps } from './ExternalLink.props';
import { LinkStyled } from './ExternalLink.styles';

export const ExternalLink: React.FC<LinkProps> = ({
  children,
  color,
  underline = UnderlineTypeProps.Always,
  href,
  target,
  onClick,
}) => {
  return (
    <LinkStyled
      component="a"
      href={href}
      target={target}
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      color={color}
      underline={underline}
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      onPointerDown={(e: React.PointerEvent<HTMLAnchorElement>) => {
        e.stopPropagation();
      }}
    >
      {children}
    </LinkStyled>
  );
};
